'use memo';

import { createFileRoute, useParams } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { OfficialDocumentsTable } from '@/routes/_staff/person/$id/_profile/official-documents/-components/OfficialDocumentsTable';
import { isPersonOfficialDocumentTabEnabled } from '@/routes/_staff/person/$id/_profile/official-documents/-shared/featureFlag';

/**
 * 離籍者の公文書タブ。在籍者と同じ一覧を使う。
 *
 * 保管期間の起算日（取得時か退職時か）は書類の根拠法ごとに異なり未確定だが、
 * どちらであっても在籍中・離籍後の双方で参照できる必要があるため両方に置く。
 */
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/official-documents/')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_staff/person/alumni/$id/_profile'
  });
  if (!isPersonOfficialDocumentTabEnabled()) return <NotFound />;
  return <OfficialDocumentsTable personId={id} />;
}